module.exports = __webpack_public_path__ + "media/bg.99a8027a.mp4";